import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=37a823f0&scoped=true"
import script from "./OrderChart.vue?vue&type=script&lang=js"
export * from "./OrderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a823f0",
  null
  
)

export default component.exports